export function OktaLogo({
  className = "h-8",
  isDark = false
}: {
  className?: string;
  isDark?: boolean;
}) {
  return (
    <img
      src={isDark ? "/okta-logo-dark.jpeg" : "/okta-logo.png"}
      alt="Okta"
      className={`w-auto object-contain ${className}`}
    />
  );
}
